<script setup>
/* eslint-disable */
import { onMounted, watch, ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useRegionsStore } from '@/stores/regions';
import { useCouponsStore } from '@/stores/coupons';
import { useGeneralStore } from '@/stores/general';
import { usePreSportsStore } from '@/stores/pre_sports';
import { useDateTimeSportFiltersStore } from '@/stores/date_time_sport_filters';
import { usePlatformConfigurationStore } from '@/stores/platform_configuration';

const router = useRouter();
const regionsStore = useRegionsStore();
const couponsStore = useCouponsStore();
const preSportsStore = usePreSportsStore();
const generalStore = useGeneralStore();
const dateTimeSportFiltersStore = useDateTimeSportFiltersStore();
const platformConfigurationStore = usePlatformConfigurationStore();

const props = defineProps({
	region: {
		type: Object,
		required: true,
	}
});

const expanded = ref(null);
const checked = ref(false);

onMounted(() => {
	expanded.value = couponsStore.all_expanded;

	for (const key in props.region.competitions) {
		const competition = props.region.competitions[key];
		if (couponsStore.competition_ids.includes(competition.id)) {
			expanded.value = true;
			break;
		}
	}

});

const toggleRegionCompetitions = (region) => {
	// 1. Calculate the target state
	const selected_ids = [...couponsStore.competition_ids];
	const is_fully_selected = region.competitions.every(comp =>
		selected_ids.includes(comp.id)
	);
	const target_state = !is_fully_selected;

	// 2. Update Coupons Store
	for (const competition_key in region.competitions) {
		const competition = region.competitions[competition_key];
		couponsStore.setCompetitionState(competition.id, target_state);
	}

	// 3. Update Filters Store (Bulk)
	if (region.id == -1) {
		for (const key in region.competitions) {
			dateTimeSportFiltersStore.updateSelectedRegion(region.competitions[key].region_id, region.competitions[key].id, target_state);
		}
	} else {
		dateTimeSportFiltersStore.bulkUpdateRegion(region.id, region.competitions, target_state);
	}

}

const toggleCompetition = (competition) => {
	// 1. Toggle in the coupons store
	couponsStore.toggleCheckboxCompetition(competition.id);

	// 2. Check the new state
	const is_checked = couponsStore.isCompetitionChecked(competition.id);

	// 3. Update Filters Store (Single)
	if (props.region.id == -1) {
		dateTimeSportFiltersStore.updateSelectedRegion(competition.region_id, competition.id, is_checked);
	} else {
		dateTimeSportFiltersStore.updateSelectedRegion(props.region.id, competition.id, is_checked);
	}

}

watch(() => couponsStore.all_expanded, (newValue, oldValue) => {
	expanded.value = newValue;
})

const getTopLeaguesFixturesCount = computed(() => {
	let top_leagues = regionsStore.regionsCompetitionsCoupons.find(region => region.id == -1);

	if (!top_leagues) return 0;

	let count = 0;
	for (const competition_key in top_leagues.competitions) {
		const competition = top_leagues.competitions[competition_key];
		count += competition.fixtures_count;
	}
	return count;
})

</script>
<template>
	<div class="accordion-item-coupon" :class="{'active': expanded}" :style="expanded ? 'padding-bottom:20px' : ''">
		<div class="accordion-header-coupon">
			<div class="coupon-country coupon-checkbox-outer" >
				<input @click="toggleRegionCompetitions(region)" type="checkbox" :id="'checkbox' + region.id" :checked="couponsStore.isRegionChecked(region)"/>
				<label :for="'checkbox' + region.id">
					<div class="country-flag">
						<img :src="'/assets' + region.icon" alt="flag-country">
					</div>
					<h6 v-if="region.id != -1" >{{ region.name }}</h6>
					<h6 v-else>{{ $t('general.top_leagues') }}</h6>
				</label>
				<div class="competitions-counter" @click="expanded = !expanded">
					<span>({{ props.region.id == -1 ? getTopLeaguesFixturesCount : region.pre_fixtures_count }})</span>
				</div>
			</div>
			<div class="acoordion-icon-coupon" @click="expanded = !expanded">
				<svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9">
					<g id="Group_1063" data-name="Group 1063" transform="translate(-272 -6)">
						<g id="minimize" transform="translate(272 10)">
						<rect id="Rectangle_408" data-name="Rectangle 408" width="1" height="9" rx="0.5" transform="translate(9) rotate(90)" fill="var(--white)"/>
						</g>
						<g id="minimize-2" class="hide-icon" data-name="minimize" transform="translate(277 6) rotate(90)">
						<rect id="Rectangle_408-2" data-name="Rectangle 408" width="1" height="9" rx="0.5" transform="translate(9) rotate(90)" fill="var(--white)"/>
						</g>
					</g>
				</svg>

			</div>
		</div>

		<div v-if="expanded" class="accordion-content-coupon">
			<div class="coupon-section-content">
				<div class="coupon-section-inner">
					<div class="coupon-checkboxes">
						<template v-if="props.region.id == -1 && props.region.competitions_count > 0">
							<div class="coupon-checkbox-outer" v-for="competition in region.competitions" :key="competition.id" :class="{'active': false }" >
								<input type="checkbox" class="checkbox" :id="'competition-checkbox-' + competition.id" :checked="couponsStore.isCompetitionChecked(competition.id)" @click="toggleCompetition(competition)">
								<label :for="'competition-checkbox-' + competition.id">
									<div class="country-flag-inner">
										<img :src="'/assets' + competition.region_icon" alt="flag-country">
									</div>
									<p> <span> {{ competition.name }} {{ competition.fixtures_count != null ? '(' + competition.fixtures_count + ')' : '' }}</span> </p>
								</label>
							</div>
						</template>
						<template v-else>
							<div class="coupon-checkbox-outer" v-for="competition in region.competitions" :key="competition.id" :class="{'active': false }" >
								<input type="checkbox" class="checkbox" :id="'competition-checkbox-' + competition.id" :checked="couponsStore.isCompetitionChecked(competition.id)" @click="toggleCompetition(competition)">
								<label :for="'competition-checkbox-' + competition.id">
									<p v-if="platformConfigurationStore.isNewPreSportsLayoutEnabled"> <span> {{ competition.name }} ({{ competition.pre_fixtures_count }})</span> </p>
									<p v-else> <span> {{ competition.name }} </span> </p>
								</label>
							</div>
						</template>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>
<style scoped>
.competitions-counter {
	display: none;
}
@media screen and (max-width: 767px) {
	.competitions-counter {
		display: block;
		color: var(--white);
		font-size: 12px;
		font-weight: 500;
		margin-top: 4px;
		margin-right: 20px;
	}
}

html[dir="rtl"] .competitions-counter {
	margin-right: unset;
	margin-left: 20px;
}
.coupons-section-outer .accordion-outer-coupon .accordion-coupon .accordion-item-coupon .accordion-header-coupon .acoordion-icon-coupon svg {
	display: block;
}

@media screen and (min-width: 767px) {
	.coupons-section-outer .accordion-outer-coupon .accordion-coupon .accordion-item-coupon {
		padding-bottom: 0px;
	}
}
html[dir="rtl"] .coupons-section-outer .accordion-outer-coupon .accordion-coupon .accordion-item-coupon .accordion-header-coupon .acoordion-icon-coupon {
	width: 15px;
	position: absolute;
	left: 0;
	top: 42%;
	transform: translateY(-50%);
	right: unset;
}

@media screen and (min-width: 768px) {
	.coupons-section-outer .accordion-outer-coupon .accordion-coupon .accordion-item-coupon .accordion-header-coupon .acoordion-icon-coupon {
		top: 33%;
	}

	html[dir="rtl"] .coupons-section-outer .accordion-outer-coupon .accordion-coupon .accordion-item-coupon .accordion-header-coupon .acoordion-icon-coupon {
		top: 33%;
	}
}

html[dir="rtl"] .coupons-section-outer .accordion-outer-coupon .accordion-coupon .accordion-item-coupon .accordion-header-coupon .coupon-country.coupon-checkbox-outer input:checked + label:after {
	content: "";
	position: absolute;
	right: 6px;
	left: unset;
	top: 34%;
	display: inline-block;
	transform: rotate(225deg);
	height: 11px;
	width: 4px;
	border-top: 1px solid var(--dark-gray);
	border-bottom: unset;
	border-left: 1px solid var(--dark-gray);
	border-right: unset;
}
html[dir="rtl"] .coupons-section-outer .coupon-section-content .coupon-section-inner .coupon-checkboxes .coupon-checkbox-outer input:checked + label:after {
	content: "";
	position: absolute;
	right: 6px;
	top: 4px;
	display: inline-block;
	transform: rotate(45deg);
	height: 11px;
	width: 4px;
	border-bottom: 1px solid var(--primary);
	border-right: 1px solid var(--primary);
}
.coupons-section-outer .accordion-outer-coupon .accordion-coupon .accordion-item-coupon .accordion-header-coupon .coupon-country h6 {
	color: var(--white);
	padding-left: 3px;
}

.country-flag-inner {
	width: 18px;
	height: 15px;
	border-radius: 50%;
	overflow: hidden;
	display: flex;
	align-items: center;
	margin-top: 3px;
}

.country-flag-inner img {
	width: 16px;
	height: 23px;
	-o-object-fit: cover;
	object-fit: cover;
	-o-object-position: center;
	object-position: center;
}

@media screen and (max-width: 375px) {
	.country-flag-inner {
		width: 15px;
		height: 12px;
	}

	.country-flag-inner img {
		width: 12px;
		height: 20px;
	}
}

.coupons-section-outer .coupon-section-content .coupon-section-inner .coupon-checkboxes .coupon-checkbox-outer input + label:before {
	min-width: 16px;
	width: 16px;
}
</style>
